export default __webpack_public_path__ + "static/media/flagSpecial4.b5956685.svg";